const TOC_ID = 'article-toc';
const CONTENT_SELECTOR = '.blog-post-content';

/**
 * Builds a table of contents from h2 and h3 headings inside the article body.
 * Runs only when the article contains <div id="article-toc"></div>.
 */
function buildArticleToc() {
  const toc = document.getElementById(TOC_ID);
  const content = toc?.closest(CONTENT_SELECTOR);
  if (!toc || !content || toc.dataset.tocReady === 'true') return;

  const headings = [...content.querySelectorAll('h2, h3')].filter((heading) => !toc.contains(heading));
  if (headings.length === 0) return;

  const usedIds = new Set();
  const list = document.createElement('ol');
  list.className = 'article-toc__list';

  /** @type {HTMLLIElement | null} */
  let currentSection = null;
  /** @type {HTMLOListElement | null} */
  let sublist = null;

  headings.forEach((heading) => {
    if (!heading.id) {
      heading.id = uniqueHeadingId(heading.textContent, usedIds);
    } else {
      usedIds.add(heading.id);
    }

    const item = document.createElement('li');
    item.className = `article-toc__item article-toc__item--${heading.tagName.toLowerCase()}`;

    const link = document.createElement('a');
    link.href = `#${heading.id}`;
    link.textContent = heading.textContent.replace(/\s+/g, ' ').trim();
    item.append(link);

    if (heading.tagName === 'H2') {
      list.append(item);
      currentSection = item;
      sublist = null;
      return;
    }

    if (!currentSection) {
      list.append(item);
      return;
    }

    if (!sublist) {
      sublist = document.createElement('ol');
      sublist.className = 'article-toc__sublist';
      currentSection.append(sublist);
    }
    sublist.append(item);
  });

  list.id = 'article-toc-list';

  const title = document.createElement('p');
  title.className = 'article-toc__title';
  title.textContent = '目次';

  const toggle = document.createElement('button');
  toggle.type = 'button';
  toggle.className = 'article-toc__toggle';
  toggle.setAttribute('aria-controls', list.id);

  const setExpanded = (expanded) => {
    toggle.setAttribute('aria-expanded', String(expanded));
    toggle.textContent = expanded ? '非表示' : '表示';
    toggle.setAttribute('aria-label', expanded ? '目次を非表示' : '目次を表示');
    list.hidden = !expanded;
  };

  setExpanded(true);
  toggle.addEventListener('click', () => {
    setExpanded(toggle.getAttribute('aria-expanded') !== 'true');
  });

  const header = document.createElement('div');
  header.className = 'article-toc__header';
  header.append(title, toggle);

  const nav = document.createElement('nav');
  nav.className = 'article-toc';
  nav.setAttribute('aria-label', '目次');
  nav.append(header, list);

  toc.replaceChildren(nav);
  toc.dataset.tocReady = 'true';
}

/**
 * @param {string | null} text
 * @param {Set<string>} usedIds
 */
function uniqueHeadingId(text, usedIds) {
  const base =
    (text ?? '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^\p{L}\p{N}-]+/gu, '')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '') || 'section';

  let id = base;
  let index = 2;
  while (usedIds.has(id) || document.getElementById(id)) {
    id = `${base}-${index}`;
    index += 1;
  }
  usedIds.add(id);
  return id;
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', buildArticleToc);
} else {
  buildArticleToc();
}
